import { cloneDeep, lastIndexOf } from 'lodash';
import { Route, RouteRecord } from 'vue-router';

const ROUTER_HISTORY_KEY = 'tabHistory';

// exclude `instances` and `components` since they have circular reference through vue
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IRouteRecordWithoutCircularReference extends Omit<RouteRecord, 'instances' | 'components'> {}

export interface IRouteWithoutCircularReference extends Omit<Route, 'matched'>{
  matched: IRouteRecordWithoutCircularReference[];
}

export default class TabHistory {
  public static stack: IRouteWithoutCircularReference[] = [];
  public static maxLength = 100;

  static get history() {
    return this.stack;
  }

  static lastVisitedOf(paths: string[]) {
    const mostRecentPathIndexes = paths.map(path => { return lastIndexOf(this.stack.map(s => s.name), path) });

    const mostRecentMatchedPath: number = cloneDeep(mostRecentPathIndexes).sort((a, b) => { return b - a })[0];

    if (mostRecentMatchedPath < 0) return null;

    const lastVisitedIndex = mostRecentPathIndexes.findIndex(path => { return path === mostRecentMatchedPath });

    return paths[lastVisitedIndex] || null;
  }

  static restoreHistory() {
    const history = window.sessionStorage.getItem(ROUTER_HISTORY_KEY);

    if (!history) return;

    this.stack = JSON.parse(history);
  }

  static clear() {
    this.stack = [];
    this.updateSessionStorage([]);
  }

  static add(element: IRouteWithoutCircularReference) {
    this.stack.push(element);
    this.pruneLength();
    this.updateSessionStorage(this.stack);
  }

  private static pruneLength() {
    if (this.stack.length > this.maxLength) { this.stack = this.stack.slice(-this.maxLength) }
  }

  private static updateSessionStorage(stack: IRouteWithoutCircularReference[]) {
    window.sessionStorage.setItem(ROUTER_HISTORY_KEY, JSON.stringify(stack));
  }
}
